<template>
  <main class="nosotros-page">
    <section class="nosotros-hero">
      <div class="hero-copy">
        <span class="eyebrow">Bodega mayorista en Bucaramanga</span>
        <h1>Maxica, surtido real para vender con confianza.</h1>
        <p>
          Trabajamos moda, calzado, bolsos, accesorios, maquillaje y líneas de
          temporada para clientes mayoristas que necesitan precio, variedad y
          atención cercana.
        </p>
        <div class="hero-actions">
          <a :href="brand.groupsUrl" class="primary-action">
            <i class="mdi mdi-whatsapp"></i>
            Ver grupos mayoristas
          </a>
          <a :href="brand.mapsUrl" target="_blank" rel="noopener" class="secondary-action">
            <i class="mdi mdi-map-marker-radius-outline"></i>
            Cómo llegar
          </a>
        </div>
      </div>

      <div class="hero-panel">
        <img :src="brand.logo" alt="Maxica" />
        <strong>{{ brand.name }}</strong>
        <span>{{ brand.address }}</span>
      </div>
    </section>

    <section class="quick-grid" aria-label="Accesos rápidos">
      <a
        v-for="action in quickActions"
        :key="action.title"
        :href="action.url"
        :target="esExterno(action.url) ? '_blank' : null"
        :rel="esExterno(action.url) ? 'noopener' : null"
        class="quick-card"
      >
        <i :class="['mdi', action.icon]"></i>
        <span>
          <strong>{{ action.title }}</strong>
          <small>{{ action.text }}</small>
        </span>
      </a>
    </section>

    <section class="about-band">
      <div>
        <h2>Más de 10 años surtiendo negocios y clientes Maxica.</h2>
      </div>
      <p>
        Nuestro equipo acompaña compras al por mayor y al detal con catálogo
        actualizado, envíos nacionales y grupos por línea para que encuentres
        rápido lo que quieres vender o comprar.
      </p>
    </section>

    <section class="groups-section">
      <div class="section-heading">
        <span>Comunidades WhatsApp</span>
        <h2>Únete al grupo que más te interesa.</h2>
        <p>
          Cada comunidad se mueve por línea, así recibes novedades sin perderte
          entre mensajes que no necesitas.
        </p>
      </div>

      <div class="group-grid">
        <a
          v-for="group in featuredGroups"
          :key="group.title"
          :href="group.url"
          target="_blank"
          rel="noopener"
          class="group-card"
          :style="{ '--accent': group.accent }"
        >
          <span class="group-icon"><i :class="['mdi', group.icon]"></i></span>
          <span class="group-copy">
            <strong>{{ group.title }}</strong>
            <small>{{ group.text }}</small>
          </span>
          <i class="mdi mdi-arrow-right"></i>
        </a>
      </div>

      <a :href="brand.groupsUrl" class="all-groups-link">
        Ver todos los grupos en una sola página
        <i class="mdi mdi-open-in-new"></i>
      </a>
    </section>
  </main>
</template>

<script>
import { maxicaBrand, quickActions, wholesaleGroups } from "@/data/maxicaLinks";

export default {
  name: "NosotrosMaxica",
  data() {
    return {
      brand: maxicaBrand,
      quickActions,
      featuredGroups: [...wholesaleGroups].sort((a, b) => (a.order || 0) - (b.order || 0)).slice(0, 6),
    };
  },
  methods: {
    esExterno(url) {
      return /^https?:\/\//i.test(url || "");
    },
  },
};
</script>

<style scoped>
.nosotros-page {
  min-height: 100vh;
  background: #f5f1ea;
  color: #191714;
}

.nosotros-hero {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(260px, 0.55fr);
  gap: 28px;
  max-width: 1120px;
  margin: 0 auto;
  padding: 64px 20px 26px;
  align-items: stretch;
}

.hero-copy {
  min-height: 420px;
  padding: 48px;
  background:
    linear-gradient(rgba(20, 18, 15, 0.68), rgba(20, 18, 15, 0.68)),
    url("../../../public/img/maxica-logo.jpg") center/300px no-repeat,
    #191714;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  border-radius: 8px;
}

.eyebrow,
.section-heading span {
  color: #d9b45f;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0;
  font-weight: 800;
}

.hero-copy h1 {
  max-width: 720px;
  margin: 14px 0 14px;
  font-size: clamp(2.1rem, 4vw, 4.4rem);
  line-height: 0.98;
  letter-spacing: 0;
}

.hero-copy p {
  max-width: 640px;
  margin: 0;
  color: #eee8de;
  font-size: 1.05rem;
  line-height: 1.7;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 28px;
}

.primary-action,
.secondary-action,
.all-groups-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px;
  border-radius: 8px;
  font-weight: 800;
  text-decoration: none;
}

.primary-action {
  background: #d9b45f;
  color: #191714;
}

.secondary-action {
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.hero-panel {
  border-radius: 8px;
  background: #ffffff;
  padding: 28px;
  border: 1px solid #e4ddd1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 320px;
}

.hero-panel img {
  width: 118px;
  height: 118px;
  object-fit: contain;
  background: #191714;
  border-radius: 8px;
  padding: 14px;
  margin-bottom: auto;
}

.hero-panel strong {
  font-size: 1.5rem;
  line-height: 1.08;
  margin-bottom: 12px;
}

.hero-panel span {
  color: #6c6258;
  line-height: 1.5;
}

.quick-grid {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 20px 48px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.quick-card {
  min-height: 112px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e4ddd1;
  border-radius: 8px;
  color: #191714;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 14px;
}

.quick-card i {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  background: #f0e6d7;
  color: #191714;
  border-radius: 8px;
  font-size: 24px;
  flex: 0 0 auto;
}

.quick-card strong,
.quick-card small {
  display: block;
}

.quick-card strong {
  font-size: 1rem;
  margin-bottom: 4px;
}

.quick-card small {
  color: #6c6258;
  line-height: 1.35;
}

.about-band {
  background: #ffffff;
  border-top: 1px solid #e4ddd1;
  border-bottom: 1px solid #e4ddd1;
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  gap: 28px;
  padding: 44px max(20px, calc((100vw - 1120px) / 2));
}

.about-band h2,
.groups-section h2 {
  margin: 0;
  color: #191714;
  font-size: clamp(1.8rem, 3vw, 3rem);
  line-height: 1.05;
}

.about-band p {
  margin: 0;
  color: #4f4840;
  font-size: 1.02rem;
  line-height: 1.75;
}

.groups-section {
  max-width: 1120px;
  margin: 0 auto;
  padding: 52px 20px 76px;
}

.section-heading {
  max-width: 620px;
  margin-bottom: 24px;
}

.section-heading h2 {
  margin-top: 8px;
}

.section-heading p {
  color: #5f574f;
  line-height: 1.7;
  margin: 12px 0 0;
}

.group-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.group-card {
  position: relative;
  min-height: 116px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e4ddd1;
  border-left: 6px solid var(--accent);
  border-radius: 8px;
  color: #191714;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 12px;
}

.group-card > .mdi-arrow-right {
  margin-left: auto;
  color: #9a9085;
}

.group-icon {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  background: #f1e7d8;
  color: #191714;
  flex: 0 0 auto;
}

.group-icon i {
  font-size: 24px;
}

.group-copy strong,
.group-copy small {
  display: block;
}

.group-copy strong {
  font-size: 1rem;
  margin-bottom: 5px;
}

.group-copy small {
  color: #675f56;
  line-height: 1.35;
}

.all-groups-link {
  margin-top: 18px;
  background: #191714;
  color: #fff;
}

@media (max-width: 900px) {
  .nosotros-hero,
  .about-band {
    grid-template-columns: 1fr;
  }

  .hero-copy {
    min-height: 360px;
    padding: 32px;
  }

  .quick-grid,
  .group-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 620px) {
  .nosotros-hero {
    padding-top: 28px;
  }

  .hero-copy {
    min-height: 430px;
    padding: 26px 20px;
    background-size: 240px;
  }

  .hero-actions {
    flex-direction: column;
  }

  .primary-action,
  .secondary-action,
  .all-groups-link {
    width: 100%;
  }

  .hero-panel {
    min-height: 220px;
  }

  .quick-grid,
  .group-grid {
    grid-template-columns: 1fr;
  }

  .about-band {
    padding-top: 34px;
    padding-bottom: 34px;
  }
}
</style>
